import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { formatDateForDisplay } from '../../../../helpers/date-time';

import Lozenge from '../../../../component-library/lozenge';
import Icon from '../../../../component-library/icon';
import ButtonIcon from '../../../../component-library/button-icon';
import StatusIndicator from '../../../../component-library/status-indicator';

const SpecificationDetails = ({
	specification,
	methods,
}) => {
	const [open, setOpen] = useState(false);

	const truncateDescription = string => {
		const length = 150;
		if (string.length > length) {
			return `${string.slice(0, length)}...`;
		}
		return string;
	};

	const viewDetails = id => {
		window.location.href = `/store/catalog/details/${id}`;
	};

	return (
		<div className="bundle-details__container">
			<div
				onClick={() => setOpen(!open)}
				role="presentation"
				className="bundle-details__details flex-row justify-space-between align-items-center"
			>
				<div>
					<h4 className="display-inline-block margin-right-8">{specification.name}</h4>
					{specification.version && (
						<span className="grey-text margin-right-16">{`V${specification.version}`}</span>
					)}
					<div className="display-inline-block">
						<StatusIndicator state={specification.state} />
					</div>
					<p className="margin-bottom-none">{truncateDescription(specification.description)}</p>
				</div>
				<div className="search-card__status flex-row align-items-center">
					{open ? (
						<Icon icon="chevron-up" />
					) : (
						<Icon icon="chevron-down" />
					)}
				</div>
			</div>
			<div className={`bundle-details__methods ${open && 'is-open'}`}>
				<table className="table is-bordered">
					<thead>
						<tr>
							<th>Behaviour</th>
							<th>Name</th>
							<th>Description</th>
							<th>URI</th>
							<th>Last Updated</th>
						</tr>
					</thead>
					<tbody>
						{specification.operations.map((item, index) => (
							methods.some(e => e.operationSpecificationId === item.id) && (
								// eslint-disable-next-line react/no-array-index-key
								<tr key={index}>
									<td>
										<Lozenge
											label={item.operationBehaviour}
										/>
									</td>
									<td>{item.name}</td>
									<td className="truncated" title={item.description}>{item.description}</td>
									<td>{item.uri}</td>
									<td>{formatDateForDisplay(item.dateUpdated)}</td>
								</tr>
							)
						))}
					</tbody>
				</table>
				<div className="text-right margin-top-16">
					<ButtonIcon
						icon="chevron-right"
						label="View Full API Details"
						iconRight
						onClick={() => viewDetails(specification.id)}
					/>
				</div>
			</div>
		</div>
	);
};

export default SpecificationDetails;

SpecificationDetails.propTypes = {
	specification: PropTypes.shape({
		id: PropTypes.number.isRequired,
		name: PropTypes.string.isRequired,
		version: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		operations: PropTypes.arrayOf(
			PropTypes.shape({}).isRequired,
		).isRequired,
		interfaceType: PropTypes.shape({
			name: PropTypes.string.isRequired,
		}).isRequired,
		state: PropTypes.objectOf.isRequired,
	}).isRequired,
	methods: PropTypes.arrayOf(
		PropTypes.shape({
			operationSpecificationId: PropTypes.number.isRequired,
		}).isRequired,
	).isRequired,
};
